import { UPDATE_ERROR_VALIDATIONS, UPDATE_SUCCESS_VALIDATIONS } from "./actionTypes";
import { updateStoresData, getExistingData } from "./vtrIndexedDB";
import { setUpdatingValidations } from "./actionIdx";

export const updateValidations = ({ response, username, password }) => (dispatch) => {
  dispatch(setUpdatingValidations());
  updateStoresData(response, username, password).then(() => {
    getExistingData()
      .then((data) => {
        dispatch({
          type: UPDATE_SUCCESS_VALIDATIONS,
          validationPayload: data,
        });
      })
      .catch((err) => {
        console.error("error: ", err);
        dispatch({
          type: UPDATE_ERROR_VALIDATIONS,
          payload: "No new validation data received",
        });
      });
  });
};
